// extracted by mini-css-extract-plugin
export default {"canvasPreLoad":"PictureZoom_canvasPreLoad__Kez21"};